<template>
  <div class="package-summary">
    <vb-toggle
      :vb_options="{
        id: 'package-summary__accordion',
        btn_text: 'Riepilogo della tua prenotazione',
        visible: true,
      }"
    >
      <services class="package-summary__services" :services="services" />
      <hr class="package-summary__divider" />
      <services-insurance class="package-summary__insurance" />
      <div class="package-summary__pricing">
        <div class="package-summary__pricing-row">
          <span class="package-summary__pricing-note">
            Il prezzo che vedi è già comprensivo delle riduzioni o eventuali
            gratuità previste per i bambini.
            <template v-if="is_flight_and_stay_package">
              <br />
              * I trasferimenti potrebbero non essere sempre inclusi. Per maggiori
              dettagli, verifica le informazioni presenti nel pacchetto scelto o
              contatta la nostra assistenza.
            </template>
          </span>
          <div class="package-summary__pricing-amount">
            <span class="package-summary__pricing-display">
              <span
                :class="
                  availability.is_known && availability.total < live_price
                    ? 'package-summary__pricing-display--exceeded'
                    : ''
                "
              >
                &euro; {{ live_price }}
              </span>

              <insufficient-credit-alert
                :availability="availability"
                :total_price="live_price"
                class_name="package-summary__nocredit"
                icon_class_name="package-summary__nocredit-icon ml-1"
                cta_id="alpitour-quote-insufficient-credit"
              />
            </span>
          </div>
        </div>
        <span class="package-summary__pricing-updated">
          Attenzione, il prezzo della tua soluzione è stato aggiornato.
        </span>
      </div>
    </vb-toggle>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Services from "@alpitour/components/blocks/services.vue";
import ServicesInsurance from "@alpitour/components/blocks/detail/assicurazione-medico-bagaglio.vue";
import InsufficientCreditAlert from '@alpitour/components/atoms/insufficient-credit-alert.vue'

export default {
  name: "package-summary",
  components: {
    services: Services,
    "services-insurance": ServicesInsurance,
    "insufficient-credit-alert": InsufficientCreditAlert,
  },
  props: {
    services: {
      type: Object,
      default: () => ({}),
    },
    live_price: {
      type: Number,
      default: 0,
    },
    availability: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("liveat", ["is_flight_and_stay_package"]),
  },
};
</script>

<style lang="scss" scoped>
.package-summary {
  .vb-toggle__btn {
    background-color: rgba(255, 255, 255, 0.5) !important;
    font-size: $font-size-lg;
  }

  &__services {
    padding: 0;
    margin-bottom: $grid-gutter-width;
  }

  &__divider {
    margin-bottom: $grid-gutter-width;
  }

  &__insurance {
    padding: 0;
    margin-top: 0;
  }

  &__pricing {
    border-top: 1px solid $border-color;
    margin-top: $grid-gutter-width/2;
    padding-top: $grid-gutter-width/2;
  }

  &__pricing-row {
    @include media-breakpoint-up(lg) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__pricing-amount {
    text-align: right;
    font-size: $font-size-lg;
    color: $primary;
    font-weight: $vb-font-weight-semibold;
  }

  &__pricing-display {
    display: flex;
    align-items: center;
    justify-content: center;

    @include media-breakpoint-up(md) {
      justify-content: flex-end;
    }

    &--exceeded {
      color: $dark;
    }
  }

  &__pricing-updated {
    display: block;
    text-align: right;
    color: $secondary;
  }

  &__nocredit {
    color: $secondary;
    font-size: $font-size-lg;
    display: flex;
    align-items: baseline;
    justify-content: center;
    font-weight: $vb-font-weight-semibold;
    padding: 0.625rem 0;
    margin-left: $grid-gutter-width/3;

    @include media-breakpoint-up(xl) {
      font-size: $font-size-sm;
      padding: 0;
    }
  }

  &__nocredit-icon {
    margin-left: 0.25rem;
  }
}

.services-insurance {
  padding: 0 !important;
  margin-top: 0;
  margin-bottom: 0;

  h2 {
    font-size: 1.25rem;
  }
}
</style>
